
import axios from 'axios';

const axiosBase = axios.create({
  // baseURL: 'http://localhost:3700',
 baseURL: 'https://api.elitetravelexpertsbyjta.co.uk',
});

const axiosLocal = axios.create({
  baseURL: 'http://localhost:3700',
  
});

export const UseAxios = (useLocal = false) => {
  return useLocal ? axiosLocal : axiosBase;
};
